<script>
    import { createEventDispatcher } from 'svelte'

    export let value = ''
    export let items = [
        {
            id: '*',
            text: 'Tutti',
            reset: true
        }
    ]

    $: selfValues = value.split (',')
    $: selfItems = items.map (it => {
        return {
            ...it,
            ...{
                selected: selfValues.indexOf (it.id) !== -1
            }
        }
    })

    const dispatch = createEventDispatcher ();

    const onItemClick = (bean, event) => {
        if (bean.reset) {
            selfItems.forEach (it => {
                it.selected = false
            })
        } else {
            let sel = selfItems.find (it => it.reset === true)
            if (sel)
                sel.selected = false;
        }

        bean.selected = !bean.selected;
        selfItems = [...selfItems]
        dispatch ('select', selfItems.filter(it => it.selected).map(it => it.id).join (','))
    }
</script>

<style>
    .FrequencySelector {
        background-color: #ecf2f6;
        cursor: default;
    }
    .FrequencySelector .FreqItem {
        display: inline-block;
        padding: 0 10px;
        /* font-weight: 600; */
        line-height: 20px;
        font-size: 12px;
        border-radius: 2px;
        vertical-align: top;
    }
    .FrequencySelector .FreqItem.selected {
        background-color: #6f899c;
        color: #fff;
    }
    /* .FrequencySelector .FreqItem.selected.reset {
        background-color: #2dbef9;
    } */
</style>

<div class="FrequencySelector">
    {#each selfItems as item (item.id)}
        <div class="FreqItem" class:reset={item.reset} class:selected={item.selected} on:click={e => { onItemClick (item, e) }}>
            {item.text}
        </div>
    {/each}
</div>